import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { firebaseAuth } from "../firebase";
import logo from "../assets/logo.webp";
import "../styles/ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setErrorMessage("");
    if (!email.trim()) {
      setErrorMessage("❌ يرجى إدخال البريد الإلكتروني.");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrorMessage("❌ البريد الإلكتروني غير صالح.");
      return;
    }

    setIsLoading(true);
    try {
      await firebaseAuth.forgotPassword(email);
      setIsSuccess(true);
    } catch (error) {
      console.error("Forgot password error:", error);
      if (error.message.includes("USER_NOT_FOUND") || error.message.includes("user-not-found")) {
        setErrorMessage("❌ لا يوجد حساب مرتبط بهذا البريد الإلكتروني.");
      } else {
        setErrorMessage("❌ حدث خطأ، يرجى المحاولة مجدداً.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <div className="forgot-container">
      <img src={logo} alt="لوغو دارس" className="auth-logo" />

      {!isSuccess ? (
        <>
          <div className="forgot-icon">🔑</div>
          <h2>نسيت كلمة المرور؟</h2>
          <p className="forgot-subtitle">
            أدخل بريدك الإلكتروني وسنرسل إليك رابط إعادة تعيين كلمة المرور
          </p>

          <input
            type="email"
            placeholder="📧 البريد الإلكتروني"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={isLoading}
            autoFocus
          />

          {errorMessage && <p className="error-message">{errorMessage}</p>}

          <button onClick={handleSubmit} disabled={isLoading} className="primary-btn">
            {isLoading ? "⏳ جارٍ الإرسال..." : "📨 إرسال رابط الاستعادة"}
          </button>

          <button className="back-btn" onClick={() => navigate("/login")} disabled={isLoading}>
            ← العودة لتسجيل الدخول
          </button>
        </>
      ) : (
        <div className="success-box">
          <div className="success-icon">✅</div>
          <h2>تم الإرسال بنجاح!</h2>
          <p>
            تم إرسال رابط إعادة تعيين كلمة المرور إلى <strong>{email}</strong>
          </p>
          <p className="hint-text">تفقّد صندوق الوارد أو مجلد Spam</p>

          <button
            className="back-btn"
            onClick={() => {
              setIsSuccess(false);
              setEmail("");
              setErrorMessage("");
            }}
          >
            🔄 إرسال مجدداً
          </button>

          <button className="primary-btn" onClick={() => navigate("/login")}>
            ← العودة لتسجيل الدخول
          </button>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
